import api, { ApiResponse } from './api'
import type { AgreementSelection } from './merchantAgreement'

interface KycStatusResponse {
  status?: string
  type?: string
  submittedAt?: number
  reviewedAt?: number
  rejectReason?: string
}

export type BusinessKycRequest = {
  businessName: string
  legalRepresentativeName: string
  companyAddress: string
  website?: string
  legalPersonIdFrontUrl: string
  legalPersonIdBackUrl: string
  certificateOfIncorporationUrl: string
  businessRegistrationUrl: string
  shareholderStructureUrl: string
  narOrNcc1Url: string
} & AgreementSelection

export type PersonalKycRequest = {
  nationality: string
  fullName: string
  gender: 'MALE' | 'FEMALE' | 'OTHER'
  birthDate: string
  documentType: 'PASSPORT' | 'ID_CARD' | 'DRIVER_LICENSE' | 'OTHER'
  documentNumber: string
  address: string
  documentFrontUrl: string
  documentBackUrl: string
  heldIdPhotoUrl: string
} & AgreementSelection

interface KycResponse {
  id: string
  type: string
  status: string
  createdAt: number
}

interface UploadResponse {
  url: string
}

export function getKycStatus(): Promise<ApiResponse<KycStatusResponse>> {
  return api.get('/v1/merchant/kyc/status')
}

export function submitBusinessKyc(data: BusinessKycRequest): Promise<ApiResponse<KycResponse>> {
  return api.post('/v1/merchant/kyc/business', data)
}

export function getPersonalKycStatus(): Promise<ApiResponse<KycStatusResponse>> {
  return api.get('/v1/merchant/kyc/personal/status')
}

export function submitPersonalKyc(data: PersonalKycRequest): Promise<ApiResponse<KycResponse>> {
  return api.post('/v1/merchant/kyc/personal', data)
}

export function getKycRecords(): Promise<ApiResponse<KycResponse[]>> {
  return api.get('/v1/merchant/kyc/records')
}

export function uploadKycDocument(file: File): Promise<ApiResponse<UploadResponse>> {
  const formData = new FormData()
  formData.append('file', file)
  return api.post('/v1/merchant/upload/kyc', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
